/* @flow */

const createMockAd = (): HTMLElement => {
  const ad = document.createElement('ins');
  ad.className = 'AdSense';
  ad.style.display = 'block';
  ad.style.position = 'absolute';
  ad.style.top = '-1px';
  ad.style.height = '1px';
  return ad;
};

export default createMockAd;
